import { mkTrackAttrs } from '@/analytics/track';

const PREFIX = 'lit_table' as const;

// Add Column Cancel Button
export const mkAddColumnCancelBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__add_column__cancel_btn`, props);

// Add Column Mark Meta Check
export const mkAddColumnMarkMetaCheckTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__add_column__mark_meta_check`, props);

// Add Column Meta Info
export const mkAddColumnMetaTooltipTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__add_column__meta_tooltip`, props);

// Add Column Submit Button
export const mkAddColumnSubmitBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__add_column__submit_btn`, props);

// Cell Refresh Button
export const mkCellRefreshBtnTrackAttrs = (props: {
  columnId: string;
  rowId: string;
}) => mkTrackAttrs(`${PREFIX}__cell__refresh_btn`, props);

// Close Button
export const mkCloseBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__close_btn`, props);

// Column Delete Button
export const mkColumnDeleteBtnTrackAttrs = (props: { columnId: string }) =>
  mkTrackAttrs(`${PREFIX}__column__delete_btn`, props);

// Column Edit Definition Button
export const mkColumnEditDefinitionBtnTrackAttrs = (props: {
  columnId: string;
}) => mkTrackAttrs(`${PREFIX}__column__edit_definition_btn`, props);

// Column More Menu Button
export const mkColumnMoreMenuBtnTrackAttrs = (props: { columnId: string }) =>
  mkTrackAttrs(`${PREFIX}__column__more_menu_btn`, props);

// Edit Column Cancel Button
export const mkEditColumnCancelBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__edit_column__cancel_btn`, props);

// Edit Column Mark Meta Check
export const mkEditColumnMarkMetaCheckTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__edit_column__mark_meta_check`, props);

// Edit Column Meta Info
export const mkEditColumnMetaTooltipTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__edit_column__meta_tooltip`, props);

// Edit Column Submit Button
export const mkEditColumnSubmitBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__edit_column__submit_btn`, props);

// Header Add Column Button
export const mkHeaderAddColumnBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__header__add_column_btn`, props);

// Header Delete Selected Button
export const mkHeaderDeleteSelectedBtnTrackAttrs = (props: {
  selectedRowCount: number;
}) => mkTrackAttrs(`${PREFIX}__header__delete_selected_btn`, props);

// Header Select All Check
export const mkHeaderSelectAllCheckTrackAttrs = (props: {
  selectedRowCount: number;
}) => mkTrackAttrs(`${PREFIX}__header__select_all_check`, props);

// Related Add Selected Button
export const mkRelatedAddSelectedBtnTrackAttrs = (props: {
  selectedRowCount: number;
}) => mkTrackAttrs(`${PREFIX}__related__add_selected_btn`, props);

// Related Close Button
export const mkRelatedCloseBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__related__close_btn`, props);

// Related Column Delete Button
export const mkRelatedColumnDeleteBtnTrackAttrs = (props: {
  columnId: string;
}) => mkTrackAttrs(`${PREFIX}__related__column__delete_btn`, props);

// Related Column Edit Definition Button
export const mkRelatedColumnEditDefinitionBtnTrackAttrs = (props: {
  columnId: string;
}) => mkTrackAttrs(`${PREFIX}__related__column__edit_definition_btn`, props);

// Related Row More Menu Button
export const mkRelatedColumnMoreMenuBtnTrackAttrs = (props: {
  columnId: string;
}) => mkTrackAttrs(`${PREFIX}__related__column__more_menu_btn`, props);

// Related Open Button
export const mkRelatedOpenBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__related__open_btn`, props);

// Related Row Delete Button
export const mkRelatedRowDeleteBtnTrackAttrs = (props: { rowId: string }) =>
  mkTrackAttrs(`${PREFIX}__related__row__delete_btn`, props);

// Related Row More Menu Button
export const mkRelatedRowMoreMenuBtnTrackAttrs = (props: { rowId: string }) =>
  mkTrackAttrs(`${PREFIX}__related__row__more_menu_btn`, props);

// Related Row Select Check
export const mkRelatedRowSelectCheckTrackAttrs = (props: {
  rowId: string;
  index: number;
}) => mkTrackAttrs(`${PREFIX}__related__row__select_check`, props);

// Related Select All Check
export const mkRelatedSelectAllCheckTrackAttrs = (props: {
  selectedRowCount: number;
}) => mkTrackAttrs(`${PREFIX}__related__select_all_check`, props);

// Row Delete Button
export const mkRowDeleteBtnTrackAttrs = (props: { rowId: string }) =>
  mkTrackAttrs(`${PREFIX}__row__delete_btn`, props);

// Row More Menu Button
export const mkRowMoreMenuBtnTrackAttrs = (props: { rowId: string }) =>
  mkTrackAttrs(`${PREFIX}__row__more_menu_btn`, props);

// Row Select Check
export const mkRowSelectCheckTrackAttrs = (props: {
  rowId: string;
  index: number;
}) => mkTrackAttrs(`${PREFIX}__row__select_check`, props);
